import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import React from 'react';
import CancelIcon from '@mui/icons-material/Cancel';
import { IconButton } from '@mui/material';
import Button from '../../../../../../components/Button/Button';
import {
	hideLoader,
	showLoader,
} from '../../../../../../components/CustomLoader/CustomLoader';
import useApiService from '../../../../../../services/api.service';
import { useAIEmailContext } from '../../../AIEmailContext';
import AIEmailGeneratorEndpoints from '../../../AIEmailGenerator.endpoints';
import useToast from '../../../../../../components/Toast/hooks/useToast';
import Dropdown from '../../../../../../components/Dropdown/Dropdown';
import '../EmailBody.scss';

const FilterModal: React.FC<any> = (props: any, ref: any) => {
	const APIService = useApiService();
	const toaster = useToast();

	const { emailData, setEmailData } = useAIEmailContext();

	const onFilterChange = async () => {
		const { email_type, email_msg } = emailData.data;
		const request = {
			email_type,
			contact_name: props.contactName,
			company_name: props.companyName,
			email_msg,
		};

		showLoader();
		try {
			const res: any = await APIService.post(
				AIEmailGeneratorEndpoints.filterEmails(request),
				true
			);
			setEmailData((prev) => ({
				...prev,
				data: {
					...prev.data,
					email_msg: res.data?.email_msg ?? [],
					email_type: res.data?.email_type ?? null,
				},
				total_emails: res?.total_emails ?? 0,
			}));
			hideLoader();
		} catch (err) {
			console.error(err);
		} finally {
			hideLoader();
			props.handleClose();
		}
	};

	const onApply = () => {
		const company = props.companyName?.trim();
		const contact = props.contactName?.trim();
	  
		const bothEmpty = !company && !contact;
		const bothFilled = company && contact;
	  
		if (!bothEmpty && !bothFilled) {
		  toaster.addToast({
			message: 'Please fill the Required Fields',
			timeout: 2000,
			type: 'error',
		  });
		  return;
		}
	  
		onFilterChange();
	  };
	  

	const onReset = () => {
		props.setContactName('');
		props.setCompanyName('');

	};

	return (
		<div className='AddAttributeDialog'>
			<Dialog
				open={true}
				onClose={props.handleClose}
				aria-labelledby='alert-dialog-title'
				aria-describedby='alert-dialog-description'
				classes={{
					paper: 'AddAttributeDialog__root',
				}}
			>
				<DialogTitle
					id='alert-dialog-title'
					classes={{
						root: 'AddAttributeDialog__titleRoot',
					}}
				>
					Filter Emails
					<IconButton
						className='AddAttributeDialog__closeBtn'
						onClick={props.handleClose}
					>
						<CancelIcon />
					</IconButton>
				</DialogTitle>

				<DialogContent
					style={{
						display: 'flex',
						alignItems: 'center',
						flexDirection: 'column',
						gap: '10px',
					}}
				>
					{props.showCompanyNameDropdown && (
						<Dropdown
							showIcons={true}
							valueSelector='value'
							itemList={props?.emailData?.company_names || []}
							selectedValue={props.companyName}
							outerClass='filter-field'
							label='Select Segment'
							name='Select Segment'
							labelName='Company Name'
							onChange={(e) => {
								props.setCompanyName(e.target.value);
							}}
						/>
					)}
					{props.showContactNameDropdown && (
						<Dropdown
							valueSelector='value'
							itemList={props?.emailData?.contact_names || []}
							selectedValue={props.contactName}
							outerClass='filter-field'
							label='Select Segment'
							name='Select Segment'
							labelName='Contact Name'
							onChange={(e) => {
								props.setContactName(e.target.value);
							}}
						/>
					)}
				</DialogContent>

				<DialogActions>
					<Button
						type='button'
						btnText='Apply'
						onClick={() => {
							onApply();
						}}
					/>

					<Button
						type='button'
						btnText='Reset'
						variant='outlined'
						onClick={onReset}
					/>
				</DialogActions>
			</Dialog>
		</div>
	);
};

export default FilterModal;